import { Checkbox, Grid, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface NoDataWithCheckProps {
    title: string;
    subtitle?: string;
    extraSubtitle?: string;
    declareNoDataText: string;
    checkState: boolean;
    onClickCheck: any;
}

const NoDataWithCheck = ({
    title,
    subtitle,
    extraSubtitle,
    declareNoDataText,
    checkState,
    onClickCheck
}: NoDataWithCheckProps) => {
    return (
        <Grid
            pt={14}
            pb={14}
            container
            xs
            textAlign={'center'}
            justifyContent={'center'}
            alignItems={'center'}
            direction={'column'}
        >
            <Typography variant="subtitle1" fontSize={'20px'} maxWidth={'60%'}>
                {title}
            </Typography>
            <Typography fontSize={16} color={'#384A52'} variant="h4" mt={0} pt={0} maxWidth={'580px'}>
                {subtitle}
            </Typography>
            <Typography fontSize={16} color={'#384A52'} variant="h4" mt={0} pt={0}>
                {extraSubtitle}
            </Typography>

            <Grid container xs justifyContent={'center'} alignItems={'center'} textAlign={'center'}>
                <Checkbox
                    inputProps={
                        {
                            'data-testid': 'noDataCheckbox'
                        } as React.InputHTMLAttributes<HTMLInputElement>
                    }
                    checked={checkState}
                    onChange={onClickCheck}
                />
                <Typography fontSize={16} color={'#384A52'} variant="h4" mb={0} pt={0}>
                    {declareNoDataText}
                </Typography>
            </Grid>
        </Grid>
    );
};

export { NoDataWithCheck };
